import { checkIfHasBadWordsAndSocialMedia } from "../../../../../../../helpers/et3-text-checker/social-media-and-bad-words";
import ET3Div from "../../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../../../core/et3-text";

const DescriptionBody = withLiteObserverAndTheme<{
  description: string;
  descriptionAlignment: "left" | "right";
}>((props) => {
  const { theme, description, descriptionAlignment } = props;
  const { colors, unitX } = theme;
  const { hasBadWords, hasSocialMedia } =
    checkIfHasBadWordsAndSocialMedia(description);
  const textColors = hasBadWords
    ? {
        backgroundColor: colors.all.red,
        textColor: colors.all.white
      }
    : hasSocialMedia
      ? {
          backgroundColor: colors.all.orange,
          textColor: colors.all.white
        }
      : {
          backgroundColor: colors.all.transparent,
          textColor: colors.all.maastrichtBlue
        };

  return (
    <ET3Div
      isScrollable={true}
      isExtendable={false}
      fDirection="column"
      justifyContent="flex-start"
      alignItems="center"
      withShadow={false}
      width={450}
      height={150}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <Et3Text
        fontFamily={"LIGHT"}
        fontSize={20}
        text={description}
        isSpan={false}
        color={textColors.textColor}
        style={{
          backgroundColor: textColors.backgroundColor,
          textAlign: descriptionAlignment,
          overflowWrap: "break-word",
          width: 430 * unitX,
          lineHeight: 2
        }}
      />
    </ET3Div>
  );
});

export default DescriptionBody;
